<template>
    <div :class="classes">
    <el-radio-group v-model="crrentValue" @change="change" class="wt-radio-input" :style="{display:[!isLine?'block':'']}">
        <el-radio :class="[!isLine?'radio-margin':'']" v-for="(item,index) in radios" :key="index" :label="isObject?item:item[radioValue]" :disabled="item.disabled">
			{{item.label}}
			<template v-if="item.is_slot">
			<wt-selector  class="radio-input-data" v-if="item.slot_type=='select'" :options="options" v-model="item[extraValue]" :disabled="item.extraDisabled"></wt-selector>
			<wt-input  class="radio-input-data" v-else  v-model="item[extraValue]"
            :disabled="item.extraDisabled">
            <el-button v-if="item.input_slot_name" :slot="item.input_slot_name">
                {{item.input_slot_icon}}
            </el-button>
            </wt-input>
			<span>{{item.unit}}</span>
			</template>
		</el-radio>
    </el-radio-group>
    </div>
</template>
<script>
const prefixCls = 'wt-radio-input'
export default {
  name: 'wt-radio-input',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    radioValue: {
      type: String,
      default: 'value'
    },
    isObject: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: function () {
        return []
      }
    },
    extraValue: {
      type: String,
      default: 'extra_value'
    },
    value: {
      type: [Object, String],
      default: ''
    },
    radios: {
      type: Array,
      default: function () {
        return []
      }
    },
    isLine: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      crrentValue: this.value
    }
  },
  watch: {
    value (val) {
      this.crrentValue = val
    },
    radios: {
      handler: function (val) {
        val.forEach(item => {
          if (item[this.radioValue] === this.crrentValue) {
            this.$emit('changed', item)
          }
        })
      },
      deep: true
    }
  },
  methods: {
    change (val) {
      this.$emit('input', val)
      this.radios.forEach(item => {
        if (item.value === val) {
          this.$emit('changed', item)
        }
      })
    }
  }
}
</script>
<style lang="less">
.wt-radio-input {
    display: flex;
    .radio-margin{
        margin-bottom: 10px;
        margin-left: 0
    }
    .radio-input-data {
        display: inline-block;
        margin-left: 5px;
    }
    .el-radio{
        display: flex;
        align-items: center;
        .el-radio__input{
        }
        .el-radio__label{
            display: flex;
            align-items: center
        }
    }
    .wt-select,
    .wt-input {
        max-width: 150px;
    }
    .wt-input{
        display: inline-block;
        .el-input{
            display: inline-table
        }
    }
    .wt-select {
        .el-input__suffix-inner {
            height: 40px;
            width: 25px;
            display: -webkit-box;
        }
        .el-icon-arrow-up {
            right: 5px;
        }
    }
}
</style>
